module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('b-field', {
    attrs: {
      "grouped": "",
      "group-multiline": ""
    }
  }, [_c('button', {
    staticClass: "button field is-danger",
    attrs: {
      "disabled": !_vm.checkedRows.length
    },
    on: {
      "click": function($event) {
        _vm.checkedRows = []
      }
    }
  }, [_c('b-icon', {
    attrs: {
      "icon": "close"
    }
  }), _vm._v(" "), _c('span', [_vm._v("Clear checked")])], 1), _vm._v(" "), _c('b-select', {
    model: {
      value: (_vm.checkboxPosition),
      callback: function($$v) {
        _vm.checkboxPosition = $$v
      },
      expression: "checkboxPosition"
    }
  }, [_c('option', {
    attrs: {
      "value": "left"
    }
  }, [_vm._v("Checkbox at left")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "right"
    }
  }, [_vm._v("Checkbox at right")])])], 1), _vm._v(" "), _c('b-tabs', [_c('b-tab-item', {
    attrs: {
      "label": "Table"
    }
  }, [_c('b-table', {
    attrs: {
      "data": _vm.data,
      "columns": _vm.columns,
      "checked-rows": _vm.checkedRows,
      "is-row-checkable": function (row) { return row.id !== 3; },
      "checkable": "",
      "checkbox-position": _vm.checkboxPosition
    },
    on: {
      "update:checkedRows": function($event) {
        _vm.checkedRows = $event
      }
    }
  }, [_c('template', {
    slot: "bottom-left"
  }, [_c('b', [_vm._v("Total checked")]), _vm._v(": " + _vm._s(_vm.checkedRows.length) + "\n                    ")])], 2)], 1), _vm._v(" "), _c('b-tab-item', {
    attrs: {
      "label": "Checked rows"
    }
  }, [_c('pre', [_vm._v(_vm._s(_vm.checkedRows))])])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fba1e7c"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/table/examples/ExCheckable.vue
// module id = 1205
// module chunks = 1 91